const moduleNameKey = "shotDataLineChart";

export const shotDataLineChartEn = {
  [moduleNameKey]: {
    fieldRequired: "Pick at least one field",
    labelRequired: "Define a name for each selected field",
    labelDuplicate: "Two fields share a name",
    tooManyFields: "At most 5 fields can be plotted",
    selectValues: "Select values ({count})",
    rangeEventsLabel: "Number of events",
    eventCountRequired: "Enter the number of events",
    loading: "Loading event fields...",
    noData: "No fields available for this event",
    treeLabel: "Event fields",
    pollingIntervalLabel: "Polling interval",
    pollingIntervalPlaceholder: "Select refresh interval",
    removeSeries: "Remove series",
    searchFieldsAriaLabel: "Search fields",
    noMatches: "No matches",
    searchFieldsPlaceholder: "Search fields...",
    titleLabel: "Chart Title",
    titleInputPlaceholder: "Enter chart title",
    titleRequired: "Title is required",
    machineLabel: "Machine",
    machineRequired: "Pick a machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    eventTypeLabel: "Event type",
    eventTypeRequired: "Pick an event type",
    noEventTypes: "No event types found",
    eventTypesPlaceholder: "Search event types...",
    timeRangeLabel: "Time range",
    lookbackLabel: "Lookback",
    timeframeLabel: "Timeframe",
    noLookbacks: "No lookback options found",
    lookbackPlaceholder: "Select lookback",
    startLabel: "Start",
    endLabel: "End",
    durationRequired: "Pick a duration",
    timeframeRequired: "Pick a start and end date",
    colorLabel: "Chart color",
    unitLabel: "Unit",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    scaleInvalid: "Scaling factor must be a number",
    manualYRangeLabel: "Set Y-Axis range manually",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Reset",
    yAxisBoundsRequired:
      "Enter both Y min and Y max, or turn off manual Y range.",
    yAxisRangeInvalid: "Y min must be less than Y max",
    saveButton: "Save",
    cancelButton: "Cancel",
    noPollingIntervals: "No polling intervals found",
  },
};

export const shotDataLineChartPtBr = {
  [moduleNameKey]: {
    fieldRequired: "Selecione pelo menos um campo",
    labelRequired: "Defina um nome para cada campo selecionado",
    labelDuplicate: "Dois campos têm o mesmo nome",
    tooManyFields: "É possível plotar no máximo 5 campos",
    selectValues: "Selecionar valores ({count})",
    rangeEventsLabel: "Número de eventos",
    eventCountRequired: "Informe o número de eventos",
    loading: "Carregando campos do evento...",
    noData: "Nenhum campo disponível para este evento",
    treeLabel: "Campos do evento",
    pollingIntervalLabel: "Intervalo de atualização",
    pollingIntervalPlaceholder: "Selecione o intervalo de atualização",
    removeSeries: "Remover série",
    searchFieldsAriaLabel: "Buscar campos",
    noMatches: "Nenhum resultado",
    searchFieldsPlaceholder: "Buscar campos...",
    titleLabel: "Título do Gráfico",
    titleInputPlaceholder: "Digite o título do gráfico",
    titleRequired: "Título é obrigatório",
    machineLabel: "Máquina",
    machineRequired: "Selecione uma máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    eventTypeLabel: "Tipo de evento",
    eventTypeRequired: "Selecione um tipo de evento",
    noEventTypes: "Nenhum tipo de evento encontrado",
    eventTypesPlaceholder: "Buscar tipos de evento...",
    timeRangeLabel: "Intervalo de tempo",
    lookbackLabel: "Janela de leitura",
    timeframeLabel: "Período",
    noLookbacks: "Nenhuma janela de leitura encontrada",
    lookbackPlaceholder: "Selecione a janela",
    startLabel: "Início",
    endLabel: "Fim",
    durationRequired: "Selecione uma duração",
    timeframeRequired: "Selecione uma data inicial e final",
    colorLabel: "Cor do gráfico",
    unitLabel: "Unidade",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    scaleInvalid: "O fator de escala deve ser um número",
    manualYRangeLabel: "Definir intervalo do eixo Y manualmente",
    yMinLabel: "Y mín",
    yMaxLabel: "Y máx",
    resetYRangeLabel: "Redefinir",
    yAxisBoundsRequired:
      "Informe Y mín e Y máx, ou desative o intervalo Y manual.",
    yAxisRangeInvalid: "Y mín deve ser menor que Y máx",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    noPollingIntervals: "Nenhum intervalo de atualização encontrado",
  },
};

export const shotDataLineChartDe = {
  [moduleNameKey]: {
    fieldRequired: "Mindestens ein Feld auswählen",
    labelRequired: "Für jedes ausgewählte Feld einen Namen festlegen",
    labelDuplicate: "Zwei Felder haben denselben Namen",
    tooManyFields: "Es können höchstens 5 Felder dargestellt werden",
    selectValues: "Werte auswählen ({count})",
    rangeEventsLabel: "Anzahl der Ereignisse",
    eventCountRequired: "Anzahl der Ereignisse eingeben",
    loading: "Ereignisfelder werden geladen...",
    noData: "Für dieses Ereignis sind keine Felder verfügbar",
    treeLabel: "Ereignisfelder",
    pollingIntervalLabel: "Aktualisierungsintervall",
    pollingIntervalPlaceholder: "Intervall wählen",
    removeSeries: "Serie entfernen",
    searchFieldsAriaLabel: "Felder suchen",
    noMatches: "Keine Treffer",
    searchFieldsPlaceholder: "Felder suchen...",
    titleLabel: "Titel des Diagramms",
    titleInputPlaceholder: "Titel des Diagramms eingeben",
    titleRequired: "Titel ist erforderlich",
    machineLabel: "Maschine",
    machineRequired: "Maschine auswählen",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    eventTypeLabel: "Ereignistyp",
    eventTypeRequired: "Ereignistyp auswählen",
    noEventTypes: "Keine Ereignistypen gefunden",
    eventTypesPlaceholder: "Ereignistypen suchen...",
    timeRangeLabel: "Zeitspanne",
    lookbackLabel: "Rückblick",
    timeframeLabel: "Zeitraum",
    noLookbacks: "Keine Rückblicke gefunden",
    lookbackPlaceholder: "Rückblick wählen",
    startLabel: "Start",
    endLabel: "Ende",
    durationRequired: "Dauer auswählen",
    timeframeRequired: "Start- und Enddatum auswählen",
    colorLabel: "Diagrammfarbe",
    unitLabel: "Einheit",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
    manualYRangeLabel: "Y-Achsenbereich manuell festlegen",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Zurücksetzen",
    yAxisBoundsRequired:
      "Y min und Y max eingeben oder den manuellen Y-Bereich ausschalten.",
    yAxisRangeInvalid: "Y min muss kleiner als Y max sein",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
    noPollingIntervals: "Keine Aktualisierungsintervalle gefunden",
  },
};

export const shotDataLineChartZhHans = {
  [moduleNameKey]: {
    fieldRequired: "请至少选择一个字段",
    labelRequired: "为每个所选字段定义名称",
    labelDuplicate: "两个字段名称相同",
    tooManyFields: "最多可绘制 5 个字段",
    selectValues: "选择值（{count}）",
    rangeEventsLabel: "事件数量",
    eventCountRequired: "输入事件数量",
    loading: "正在加载事件字段...",
    noData: "此事件没有可用字段",
    treeLabel: "事件字段",
    pollingIntervalLabel: "轮询间隔",
    pollingIntervalPlaceholder: "选择刷新间隔",
    removeSeries: "删除该序列",
    searchFieldsAriaLabel: "搜索字段",
    noMatches: "没有匹配项",
    searchFieldsPlaceholder: "搜索字段...",
    titleLabel: "图表标题",
    titleInputPlaceholder: "输入图表标题",
    titleRequired: "标题是必填项",
    machineLabel: "机器",
    machineRequired: "选择机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    eventTypeLabel: "事件类型",
    eventTypeRequired: "选择事件类型",
    noEventTypes: "未找到事件类型",
    eventTypesPlaceholder: "搜索事件类型...",
    timeRangeLabel: "时间范围",
    lookbackLabel: "回溯时间",
    timeframeLabel: "时间段",
    noLookbacks: "未找到回溯时间",
    lookbackPlaceholder: "选择回溯时间",
    startLabel: "开始",
    endLabel: "结束",
    durationRequired: "选择持续时间",
    timeframeRequired: "选择开始和结束日期",
    colorLabel: "图表颜色",
    unitLabel: "单位",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    scaleInvalid: "缩放系数必须为数字",
    manualYRangeLabel: "手动设置 Y 轴范围",
    yMinLabel: "Y 最小值",
    yMaxLabel: "Y 最大值",
    resetYRangeLabel: "重置",
    yAxisBoundsRequired: "请填写 Y 最小值和 Y 最大值，或关闭手动 Y 轴范围。",
    yAxisRangeInvalid: "Y 最小值必须小于 Y 最大值",
    saveButton: "保存",
    cancelButton: "取消",
    noPollingIntervals: "未找到轮询间隔",
  },
};

export const shotDataLineChartIt = {
  [moduleNameKey]: {
    fieldRequired: "Seleziona almeno un campo",
    labelRequired: "Definisci un nome per ogni campo selezionato",
    labelDuplicate: "Due campi hanno lo stesso nome",
    tooManyFields: "Si possono tracciare al massimo 5 campi",
    selectValues: "Seleziona valori ({count})",
    rangeEventsLabel: "Numero di eventi",
    eventCountRequired: "Inserisci il numero di eventi",
    loading: "Caricamento campi evento...",
    noData: "Nessun campo disponibile per questo evento",
    treeLabel: "Campi dell'evento",
    pollingIntervalLabel: "Intervallo di aggiornamento",
    pollingIntervalPlaceholder: "Seleziona intervallo",
    removeSeries: "Rimuovi serie",
    searchFieldsAriaLabel: "Cerca campi",
    noMatches: "Nessun risultato",
    searchFieldsPlaceholder: "Cerca campi...",
    titleLabel: "Titolo del Grafico",
    titleInputPlaceholder: "Inserisci il titolo del grafico",
    titleRequired: "Il titolo è obbligatorio",
    machineLabel: "Macchina",
    machineRequired: "Seleziona una macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    eventTypeLabel: "Tipo di evento",
    eventTypeRequired: "Seleziona un tipo di evento",
    noEventTypes: "Nessun tipo di evento trovato",
    eventTypesPlaceholder: "Cerca tipi di evento...",
    timeRangeLabel: "Intervallo di tempo",
    lookbackLabel: "Periodo di osservazione",
    timeframeLabel: "Periodo",
    noLookbacks: "Nessun periodo di osservazione trovato",
    lookbackPlaceholder: "Seleziona periodo",
    startLabel: "Inizio",
    endLabel: "Fine",
    durationRequired: "Seleziona una durata",
    timeframeRequired: "Seleziona una data di inizio e fine",
    colorLabel: "Colore grafico",
    unitLabel: "Unità",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    scaleInvalid: "Il fattore di scala deve essere un numero",
    manualYRangeLabel: "Imposta intervallo Y manualmente",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Ripristina",
    yAxisBoundsRequired:
      "Inserisci Y min e Y max oppure disattiva l'intervallo Y manuale.",
    yAxisRangeInvalid: "Y min deve essere minore di Y max",
    saveButton: "Salva",
    cancelButton: "Annulla",
    noPollingIntervals: "Nessun intervallo di aggiornamento trovato",
  },
};

export const shotDataLineChartEs = {
  [moduleNameKey]: {
    fieldRequired: "Selecciona al menos un campo",
    labelRequired: "Define un nombre para cada campo seleccionado",
    labelDuplicate: "Dos campos tienen el mismo nombre",
    tooManyFields: "Se pueden trazar como máximo 5 campos",
    selectValues: "Seleccionar valores ({count})",
    rangeEventsLabel: "Número de eventos",
    eventCountRequired: "Introduce el número de eventos",
    loading: "Cargando campos del evento...",
    noData: "No hay campos disponibles para este evento",
    treeLabel: "Campos del evento",
    pollingIntervalLabel: "Intervalo de actualización",
    pollingIntervalPlaceholder: "Seleccionar intervalo",
    removeSeries: "Eliminar serie",
    searchFieldsAriaLabel: "Buscar campos",
    noMatches: "Sin resultados",
    searchFieldsPlaceholder: "Buscar campos...",
    titleLabel: "Título del Gráfico",
    titleInputPlaceholder: "Ingrese el título del gráfico",
    titleRequired: "El título es obligatorio",
    machineLabel: "Máquina",
    machineRequired: "Seleccione una máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    eventTypeLabel: "Tipo de evento",
    eventTypeRequired: "Seleccione un tipo de evento",
    noEventTypes: "No se encontraron tipos de evento",
    eventTypesPlaceholder: "Buscar tipos de evento...",
    timeRangeLabel: "Período de tiempo",
    lookbackLabel: "Periodo de búsqueda",
    timeframeLabel: "Período",
    noLookbacks: "No se encontraron periodos de búsqueda",
    lookbackPlaceholder: "Selecciona el periodo",
    startLabel: "Desde",
    endLabel: "Hasta",
    durationRequired: "Seleccione una duración",
    timeframeRequired: "Seleccione una fecha de inicio y fin",
    colorLabel: "Color del gráfico",
    unitLabel: "Unidad",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    scaleInvalid: "El factor de escala debe ser un número",
    manualYRangeLabel: "Establecer rango del eje Y manualmente",
    yMinLabel: "Y mín",
    yMaxLabel: "Y máx",
    resetYRangeLabel: "Restablecer",
    yAxisBoundsRequired:
      "Introduce Y mín e Y máx, o desactiva el rango Y manual.",
    yAxisRangeInvalid: "Y mín debe ser menor que Y máx",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    noPollingIntervals: "No se encontraron intervalos de actualización",
  },
};

export const shotDataLineChartNl = {
  [moduleNameKey]: {
    fieldRequired: "Kies minstens één veld",
    labelRequired: "Geef elk geselecteerd veld een naam",
    labelDuplicate: "Twee velden hebben dezelfde naam",
    tooManyFields: "Er kunnen maximaal 5 velden worden getoond",
    selectValues: "Waarden selecteren ({count})",
    rangeEventsLabel: "Aantal gebeurtenissen",
    eventCountRequired: "Voer het aantal gebeurtenissen in",
    loading: "Gebeurtenisvelden laden...",
    noData: "Geen velden beschikbaar voor deze gebeurtenis",
    treeLabel: "Gebeurtenisvelden",
    pollingIntervalLabel: "Polling-interval",
    pollingIntervalPlaceholder: "Polling-interval kiezen",
    removeSeries: "Serie verwijderen",
    searchFieldsAriaLabel: "Velden zoeken",
    noMatches: "Geen resultaten",
    searchFieldsPlaceholder: "Velden zoeken...",
    titleLabel: "Grafiektitel",
    titleInputPlaceholder: "Typ de grafiektitel",
    titleRequired: "Titel is vereist",
    machineLabel: "Machine",
    machineRequired: "Kies een machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    eventTypeLabel: "Gebeurtenistype",
    eventTypeRequired: "Kies een gebeurtenistype",
    noEventTypes: "Geen gebeurtenistypen gevonden",
    eventTypesPlaceholder: "Gebeurtenistypen zoeken...",
    timeRangeLabel: "Tijdsbereik",
    lookbackLabel: "Terugkijkperiode",
    timeframeLabel: "Tijdsbestek",
    noLookbacks: "Geen terugkijkperiodes gevonden",
    lookbackPlaceholder: "Selecteer een terugkijkperiode",
    startLabel: "Start",
    endLabel: "Eind",
    durationRequired: "Kies een duur",
    timeframeRequired: "Tijdsbestek is vereist",
    colorLabel: "Grafiekkleur",
    unitLabel: "Eenheid",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    scaleInvalid: "De schaalfactor moet een getal zijn",
    manualYRangeLabel: "Stel Y-as bereik handmatig in",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Resetten",
    yAxisBoundsRequired:
      "Vul zowel Y min als Y max in, of schakel het handmatige Y-bereik uit.",
    yAxisRangeInvalid: "Y min moet kleiner zijn dan Y max",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
    noPollingIntervals: "Geen polling-intervallen gevonden",
  },
};

export const shotDataLineChartTr = {
  [moduleNameKey]: {
    fieldRequired: "En az bir alan seç",
    labelRequired: "Seçilen her alan için bir ad tanımla",
    labelDuplicate: "İki alan aynı ada sahip",
    tooManyFields: "En fazla 5 alan çizilebilir",
    selectValues: "Değerleri seç ({count})",
    rangeEventsLabel: "Olay sayısı",
    eventCountRequired: "Olay sayısını girin",
    loading: "Olay alanları yükleniyor...",
    noData: "Bu olay için kullanılabilir alan yok",
    treeLabel: "Olay alanları",
    pollingIntervalLabel: "Yoklama aralığı",
    pollingIntervalPlaceholder: "Yenileme aralığını seçin",
    removeSeries: "Seriyi kaldır",
    searchFieldsAriaLabel: "Alanları ara",
    noMatches: "Eşleşme yok",
    searchFieldsPlaceholder: "Alanları ara...",
    titleLabel: "Grafik Başlığı",
    titleInputPlaceholder: "Grafik başlığını girin",
    titleRequired: "Başlık gerekli",
    machineLabel: "Makine",
    machineRequired: "Bir makine seç",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    eventTypeLabel: "Olay türü",
    eventTypeRequired: "Bir olay türü seç",
    noEventTypes: "Olay türü bulunamadı",
    eventTypesPlaceholder: "Olay türlerini ara...",
    timeRangeLabel: "Zaman aralığı",
    lookbackLabel: "Geriye bakma",
    timeframeLabel: "Zaman aralığı",
    noLookbacks: "Hiçbir geriye bakma bulunamadı",
    lookbackPlaceholder: "Yeniden incelemeyi seçin",
    startLabel: "Başlangıç",
    endLabel: "Son",
    durationRequired: "Bir süre seçin",
    timeframeRequired: "Bir başlangıç ve bitiş tarihi seçin",
    colorLabel: "Grafik rengi",
    unitLabel: "Birim",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
    manualYRangeLabel: "Y ekseni aralığını manuel olarak ayarla",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Sıfırla",
    yAxisBoundsRequired:
      "Y min ve Y max değerlerini girin veya manuel Y aralığını kapatın.",
    yAxisRangeInvalid: "Y min, Y max'ten küçük olmalıdır",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
    noPollingIntervals: "Hiçbir yoklama aralığı bulunamadı",
  },
};
